import { DefaultPortModel, NodeModel } from '@projectstorm/react-diagrams'

export default class DuprNodeModel extends NodeModel {
  card?: any
  width: any
  height: any
  direction?: any
  disabled?: any

  constructor(options: any = {}) {
    super({
      ...options,
      type: 'js-custom-node',
    })

    this.card = options.card
    this.width = options.width
    this.height = options.height
    this.direction = options.direction
    this.disabled = options.disabled

    this.addPort(
      new DefaultPortModel({
        in: true,
        name: 'in',
      })
    )
    this.addPort(
      new DefaultPortModel({
        in: false,
        name: 'out',
      })
    )
  }

  serialize() {
    return {
      ...super.serialize(),
      card: this.card,
    }
  }

  deserialize(ob: any) {
    super.deserialize(ob)
    this.card = ob.card
  }
}
